import { render, staticRenderFns } from "./advertisementRecords.vue?vue&type=template&id=5f441dbc&scoped=true"
import script from "./advertisementRecords.vue?vue&type=script&lang=js"
export * from "./advertisementRecords.vue?vue&type=script&lang=js"
import style0 from "./advertisementRecords.vue?vue&type=style&index=0&id=5f441dbc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f441dbc",
  null
  
)

export default component.exports